/**
 * Utility functions for controlling scroll behavior
 */

/**
 * Resets scroll position on all potential scrollable containers
 * Works more reliably than just window.scrollTo(0,0)
 */
export const resetScroll = () => {
  // Standard scroll reset
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  // Find and reset all potential scrollable containers
  const scrollableElements = [
    document.querySelector('main'),
    document.querySelector('#root'),
    document.querySelector('#root > div'),
    document.querySelector('.MuiBox-root[data-testid="PageLayout"]'),
    document.querySelector('.MuiBox-root:has(.MuiContainer-root)'),
    ...document.querySelectorAll('.MuiBox-root'),
  ];

  for (const element of scrollableElements) {
    if (element instanceof HTMLElement) {
      element.scrollTop = 0;
    }
  }

  // Additional attempt with delay for browser reflow
  setTimeout(() => {
    window.scrollTo(0, 0);

    // Try again with even more specific selectors
    const boxWithFooter = document.querySelector('.MuiBox-root:has(.MuiContainer-root)');
    if (boxWithFooter instanceof HTMLElement) {
      boxWithFooter.scrollTop = 0;
    }
  }, 50);
};
